<template lang="pug">
  v-card-title(:class="isInline ? 'inline-title-bar' : 'action-title-bar'")
    .title(v-if="hasTitle" :style="cssStyle" data-cy="title")
      | {{ title }}
    .sub-title(v-if="!hideSubtitle")
      slot(name="sub-title")
    .action-slot
      slot
    div.title-bar-menu
      slot(name="menu")
    div.content-description(
      v-if="hasDescription"
      data-cy="content-description"
    ) {{description}}
    .title-bar-menu
      slot(name="actions")

    slot(name="communicationType")

    v-spacer
    slot(name="searchBox")

    span.actions-section
      slot(name="extras")
</template>

<script>

export default {
  props: {
    title: {
      default: null,
      type: String,
    },
    isInline: {
      default: false,
      type: Boolean,
    },
    description: {
      default: null,
      type: [String, Number],
    },
    hideSubtitle: {
      default: false,
      type: Boolean,
    }
  },
  computed: {
    hasDescription() {
      // return (String)(this.description).length > 0;
      if (this.description) {
        return this.description.length > 0;
      }
      return false;
    },
    hasTitle() {
      return this.title && this.title.length > 0;
    },
    cssStyle() {
      return `--tag-color:${this.$vuetify.theme.primary};`;
    },
  },
};
</script>
<style lang="scss" scoped>
  .action-title-bar {
    padding: 6px 0;
    min-height: 80px;
    width: 100%;
    margin: 10px 0 20px;
    .title {
      margin-bottom: 13px;
      width: 100%;
    }
  }
  .inline-title-bar {
    display: flex;
    padding: 10px 0px 0px 12px;
    .sub-title,
    .title {
      width: auto !important;
      margin-left: 15px !important;
    }

  }
  .inline-title-bar,
  .action-title-bar {
    .title {
      text-transform: uppercase;
      margin-left: 32px;
      &:before {
        width: 16px;
        height: 16px;
        position: absolute;
        content: "";
        margin: 2px -27px;
        border-radius: 2px;
        background: var(--tag-color);
      }
    }
    .action-slot {
      padding-right: 12px;
    }
    .content-description,
    .sub-title {
      color: var(--v-text-lighten3);
      font-size: 16px;
    }
    .content-description {
      padding: 0 12px;
    }
    .sub-title {
      width: 100%;
      padding: 0 5px;
    }
  }
  @media (max-width: 900px) {
    .actions-section {
      width: 100%;
      .layout {
        display: block;
        padding-top: 12px;
        .flex {
          text-align: center;
          width: 35%;
          float: left;
        }
      }
    }
  }
  @media (max-width: 600px) {
    .actions-section {
      .layout .flex,
      /deep/ .v-toolbar__content span {
        width: 100%;
      }
      .layout .flex:last-child {
        width: 40%;
      }
      .layout .flex:nth-last-child(2) {
        width: 60%;
      }
    }
  }
</style>